import { render, staticRenderFns } from "./PageStartsOrganizers.vue?vue&type=template&id=69178dc5&"
import script from "./PageStartsOrganizers.vue?vue&type=script&lang=js&"
export * from "./PageStartsOrganizers.vue?vue&type=script&lang=js&"
import style0 from "./PageStartsOrganizers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports